module.exports = __webpack_public_path__ + "eff2996162fdfe7c6af7995d3f790275.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/opensans-bold/opensans-bold.woff
// module id = ./src/styles/fonts/opensans-bold/opensans-bold.woff
// module chunks = index